import React from "react";
import { createRoot } from "react-dom/client";
import SpiritList from "./SpiritList";

// Same contract as the other islands. The payload is already in the document,
// so the page is a document before any script runs — and it has to re-mount on
// turbo:load, or arriving from the nav leaves the catalogue inert.
export function mount(element) {
  if (!element || element.dataset.mounted === "true") return;
  const data = JSON.parse(element.dataset.spirits);
  element.dataset.mounted = "true";
  createRoot(element).render(<SpiritList spirits={data.spirits} />);
}

function mountAll() {
  document.querySelectorAll("#solomonic-spirits").forEach(mount);
}

document.addEventListener("DOMContentLoaded", mountAll);
document.addEventListener("turbo:load", mountAll);
